// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"31d6cfe0","494":"d855259c","499":"ca8eb2e9","746":"1c97a6c1","984":"670dd95c"}[chunkId] + ".chunk.css";
};